import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@config/axios/axios.config';
import { paths } from '@common/types';

const getCaptchaDataRequest = async () => {
  const response =
    axiosInstance.get<
      paths[`/captcha`]['get']['responses']['default']['content']['application/json']
    >(`/captcha`);
  const data = (await response).data;

  return data;
};

export const useCaptchaDataQuery = () => {
  const query = useQuery({
    queryKey: ['captcha'],
    queryFn: () => getCaptchaDataRequest(),
    staleTime: 0,
    gcTime: 0,
  });

  return query;
};
